"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useChartProExport = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _print = require("./print");
var _exportImage = require("./exportImage");
function waitForAnimationFrame() {
  let resolve;
  const promise = new Promise(res => {
    resolve = res;
  });
  window.requestAnimationFrame(() => {
    resolve();
  });
  return promise;
}
const useChartProExport = ({
  chartRootRef,
  instance
}) => {
  const exportAsPrint = async options => {
    const chartRoot = chartRootRef.current;
    if (chartRoot) {
      const enableAnimation = instance.disableAnimation();
      try {
        // Wait for animation frame to ensure the animation finished
        await waitForAnimationFrame();
        (0, _print.printChart)(chartRoot, options);
      } catch (error) {
        console.error('MUI X Charts: Error exporting chart as print:', error);
      } finally {
        enableAnimation();
      }
    }
  };
  const exportAsImage = async options => {
    const chartRoot = chartRootRef.current;
    if (chartRoot) {
      const enableAnimation = instance.disableAnimation();
      try {
        // Wait for animation frame to ensure the animation finished
        await waitForAnimationFrame();
        await (0, _exportImage.exportImage)(chartRoot, options);
      } catch (error) {
        console.error('MUI X Charts: Error exporting chart as image:', error);
      } finally {
        enableAnimation();
      }
    }
  };
  return {
    publicAPI: {
      exportAsPrint,
      exportAsImage
    },
    instance: {
      exportAsPrint,
      exportAsImage
    }
  };
};
exports.useChartProExport = useChartProExport;
useChartProExport.params = {};
useChartProExport.getDefaultizedParams = ({
  params
}) => (0, _extends2.default)({}, params);
useChartProExport.getInitialState = () => ({
  export: {}
});